$(document).ready(function () {
    // Desktop Mega Menu Navigation
    $(document).on('mouseenter','.mega-menu__linklist li',function () {
    var li_index = $(this).data('index');
      $(this).addClass('active').siblings().removeClass('active');
    
      $(this).parents('.mega-menu__linklist').siblings('.menu_right_show').find(`.tabcontent[data-index="${li_index}"]`).addClass('sractive').siblings().removeClass('sractive');
  });

// Sidebar About Button Js
  $('.add').parent('li').addClass('plusmen');
  $('.plusmen').click(function(){
  $(this).toggleClass("is");
  $('.ul_same').toggleClass("add");
});
});




// $(document).ready(function () {
//     $(".header__primary-nav-item").each(function () {
//         var i = $(this);
//         $(this)
//             .find(".mega-menu__linklist .v-stack")
//             .hover(function () {
//                 $(i).find(".mega-menu__linklist .v-stack").removeClass("active"), $(this).addClass("active");
//                 var a = $(this),
//                     n = $(".mega-menu__promo").find(".v-stack");
//                 $(a).each(function () {
//                     var a = $(this).attr("data-navtitle");
//                     $(n).each(function () {
//                         var n = $(this).attr("data-navimag");
//                         a === n ? $(i).find(this).css("display", "flex") : $(i).find(this).css("display", "none");
//                     });
//                 });
//             });
//         var a = $(this).find(".mega-menu__linklist .v-stack.active").attr("data-navtitle");
//         (t = $(".mega-menu__promo").find(".v-stack")),
//             $(t).each(function () {
//                 var n = $(this).attr("data-navimag");
//                 a === n ? $(i).find(this).css("display", "flex") : $(i).find(this).css("display", "none");
//             });        
//     }),
//         $(".abtus-sidebar").click(function () {
//             $(".ul_same").toggleClass("add");
//         }),
//         $(".header__primary-nav-item").each(function () {
//             var i = $(this);
//             $(this)
//                 .find(".mega-menu__linklist .v-stack")
//                 .hover(function () {
//                     var a = $(this),
//                         n = $(".mega-menu__promo").find(".v-stack");
//                     $(a).each(function () {
//                         var a = $(this),
//                             e = $(this).attr("data-navtitle");
//                         $(n).each(function () {
//                             var n = $(this).attr("data-navimag");
//                             if (e === n) {
//                                 var s = a.attr("data-title"),
//                                     d = a.find("a").attr("data-url");
//                                 $(this).find(".image_se .menu-right-aside-header .menu-right-aside-copy").text(s), $(this).find(".image_se .menu-right-aside-header .menu-right-aside-button").attr("href", d);
//                             }
//                             ("MENS5" === n || "للرجال5" === n) &&
//                                 ($(i).find(this).addClass("menudisplay"),
//                                 $(this)
//                                     .find(".collection_product .collection_title")
//                                     .each(function () {
//                                         var i = $(this).find("li input").attr("value");
//                                         $(this).find("li img").attr("src", i);
//                                     })),
//                                 ("WOMENS5" === n || "للنساء5" === n) &&
//                                     ($(i).find(this).addClass("menudisplay"),
//                                     $(this)
//                                         .find(".collection_product .collection_title")
//                                         .each(function () {
//                                             var i = $(this).find("li input").attr("value");
//                                             $(this).find("li img").attr("src", i);
//                                         })),
//                                 ("MENS3" === n || "WOMENS2" === n || "للرجال3" === n || "للنساء2" === n) && $(i).find(this).addClass("best_sellere_val");
//                         });
//                     });
//                 });
//         });
// });
